import { render } from "./newDialog.vue?vue&type=template&id=2c618094&scoped=true"
import script from "./newDialog.vue?vue&type=script&lang=js"
export * from "./newDialog.vue?vue&type=script&lang=js"

import "./newDialog.vue?vue&type=style&index=0&id=2c618094&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c618094"]])

export default __exports__